
import DimensionsBase from './base/DimensionsBase';
/** 
 * Helper Class to retrieve the screen and window dimensions. 
 * */
export default DimensionsBase;